import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import DaumPostcode from 'react-daum-postcode';
import axios from 'axios';
import { Box, Button, Checkbox, Typography, Modal, Dialog, DialogActions, DialogTitle } from '@mui/material'
import {CgSearch} from 'react-icons/cg';



const useStyles = makeStyles((theme) => ({
    row:{
        maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'310px 0 70px 0',

        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            padding:'150px 0 0px 0',
        }
    },
    appListH3:{
        borderBottom:'2px solid #007235',
        fontSize:'22px',
        fontWeight:'400',
        paddingBottom:'10px'
    },
    joinH1:{
        textAlign:'center',
        fontSize:'35px',
    },
    joinTosFlexDiv:{
        display:'flex',
        justifyContent:'space-evenly',
        paddingTop:'3%',

        [theme.breakpoints.down(1025)]: {
            flexDirection: 'column'
        }
    },
    joinForm:{
        width:'38%',

        [theme.breakpoints.down(1025)]: {
            width:'100%',
            padding:'0 20px',
        }
    },
    appListLi:{
        padding:'40px 0 0 0px'
    },
    idOverlapDiv:{
        display:'flex',
        justifyContent:'space-between',
    },
    appContentId:{
        width:'72%'
    },
    appContentInputId:{
        width:'100%',
        height: '40px',
        padding:'0 0 0 8px',
        borderRadius:'3px',
        border:'1px solid #CCCCCC',
        '&::placeholder':{
            color:'#CCCCCC'
        },
        '&:focus-within':{
            outline:'none'
        },
        
    },
    paddingDiv:{
        paddingBottom:'10px'
    },
    pilsooItem:{

    },
    appContentIdBtn:{
        width:'25%'
    },
    pilsooItemIdBtn:{
        width:'100%',
        height: '40px',
        padding:'5px 0px',
        background:'none',
        border:'1px solid #007235',
        borderRadius:'3px',
        color:'#007235',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    appContentInput:{
        width:'100%',
        height: '40px',
        padding:'0 0 0 8px',
        borderRadius:'3px',
        border:'1px solid #CCCCCC',
        fontFamily:[
            'Noto Sans KR'
        ],
        '&::placeholder':{
            color:'#CCCCCC'
        },
        '&:focus-within':{
            outline:'none'
        },
    },
    btnDiv:{
        textAlign:'center',
        margin:'50px 0'
    },
    joinFormBtn:{
        width:'150px',
        padding:'10px 0',
        marginRight:'20px',
        '&:last-child':{ marginRight:'0'}
    },
    fileInput:{
        display: 'inline-block',
        padding: '.5em 1em',
        fontSize: 'inherit',
        backgroundColor: '#007235',
        color:'#fff',
        fontWeight:'600',
        cursor: 'pointer',
        border:'2px solid #007235',
        borderRadius: '3px',
    },
    TosForm:{
        //flexGrow:'0.6',
        width:'40%',

        [theme.breakpoints.down(1025)]: {
            width:'100%',
            padding:'20px 20px 0 20px',
        }
    },
    formH2:{
        fontSize:'16px',
        padding:'20px 0 10px 0',
        fontWeight:'400'
    },
    formTextarea:{
        width:'100%',
        height:'200px',
        background:'#DEDEDE',
        borderRadius:'3px',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    checkBoxLabel:{
        fontSize:'14px'
    },
    checkBoxInput:{
        marginRight:'5px'
    },
    formBtn:{
        marginTop:'30px',
        padding:'10px 0',
        width:'100%',
        background:'#007235',
        color:'#fff',
        fontSize:'16px',

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    addStyle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '2px solid #007235',
        borderRadius:3,
        boxShadow: 24,
        p: 4,
        [theme.breakpoints.down(1025)]: {
            width:'100%',
        }
    }
}))


const Register = () => {
    const theme = useTheme();
    const classes = useStyles(theme);
    let navigate = useNavigate();

    const [mbId, setMbId] = useState('')
    const [mbpassword, setMbPassword] = useState('')
    const [mbpassCheck, setMbPassCheck] = useState('')    

    const [mbName, setName] = useState('')
    const [mbZip1, setMbZip1] = useState('')
    const [mbZip2, setMbZip2] = useState('')
    const [mbAddr1, setMbAddr1] = useState('')
    const [mbAddr2, setMbAddr2] = useState('')
    const [mbAddr3, setMbAddr3] = useState('')
    const [mbEmail, setMbEmail] = useState('')
    const [mbHp, setMbHp] = useState('')
    const [mbSms, setMbSms] = useState(0)
    const [mbStorename, setMbStorename] = useState('')
    const [mbBizNo, setMbBizNo] = useState('')
    const [mbBizName, setMbBizName] = useState('')
    const [mbBizTaxMail, setMbBizTaxMail] = useState('')
    const [mbBizPaper, setMbBizPaper] = useState('')

    const [checked1, setChecked1] = useState(false);
    const [checked2, setChecked2] = useState(false);

    const [open, setOpen] = useState(false);
    const [idCheck, setIdCheck] = useState(false);
    const [idHas, setIdHas] = useState(false);

    const [dialog, setDialog] = useState('');
    const [loading, setLoading] = useState(false)

    const tosStipulation = useSelector(state => state.config.admConfig.cf_stipulation);
    const tosprivacy = useSelector(state => state.config.admConfig.cf_privacy);
    const regPoint = useSelector(state => state.config.admConfig.cf_register_point);
    const prohibitId = useSelector(state => state.config.admConfig.cf_prohibit_id)
    const login = useSelector(state => state.user.login);
    
    const prohibitIdList = prohibitId && prohibitId.split(',')

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (login) {
          navigate("/");
        }
      } , [login])


    const checkId = async() => {
        let regExpId = /^[a-z]+[a-z0-9]{4,13}$/g;
        if (mbId.length === 0) return;
        if (!regExpId.test(mbId)) {
            setDialog('영문자로 시작하는 영문자 또는 숫자 5~14자를 입력해주세요.')
            return
        }
        if (prohibitIdList.includes(mbId)){
            setDialog('사용할 수 없는 아이디 입니다.')
            return
        }


        try {
            const res = await axios.post('/api/user/checkid/', {mb_id: mbId})  
            if(res.data.success === false) {
                setIdCheck(false)
                setIdHas(true)
                return;
            }
            setIdCheck(true)
            setIdHas(false)
        
          } catch (e) {
            console.log(e)
          }

    }

    
    const handle = {
        // 버튼 클릭 이벤트
        handleOpen: () => {
            setOpen(current => !current);
        },

        // 주소 선택 이벤트
        selectAddress: (data) => {
            let zip1 = data.zonecode.substr(0, 3);
            let zip2 = data.zonecode.substr(3, 3);
            let addr1 = data.address

            setMbZip1(zip1)
            setMbZip2(zip2)
            setMbAddr1(addr1)
            setOpen(false);
        },
    }

    
    const valid = () => {
        let regExpEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
        if (mbId=== '') {
            setDialog('아이디를 입력 해주세요.')
            return false
        }
        if (!idCheck) {
            setDialog('아이디 중복확인을 해주세요.')
            return false
        }
        if (mbpassword.length < 5) {
            setDialog('비밀번호를 5자 이상 입력 해주세요.')
            return false
        }
        if (mbpassword !== mbpassCheck) {
            setDialog('비밀번호를 확인 해주세요.')
            return false
        }
        if (mbName === '') {
            setDialog('이름을 입력해 주세요.')
            return false
        }
        if (mbAddr1 === '') {
            setDialog('주소를 입력해 주세요.')
            return false
        }
        if (!regExpEmail.test(mbEmail)) {
            setDialog('이메일 형식을 지켜주세요.')
            return false
        }
        if (mbHp === '') {
            setDialog('휴대폰 번호를 입력해 주세요.')
            return false
        }
        if (mbHp.length !== 11) {
            setDialog('휴대폰 번호 숫자만 입력해주세요.')
            return false
        }
        if (mbStorename === '') {
            setDialog('상호명을 입력해 주세요.')
            return false
        }
        if (mbBizNo === '') {
            setDialog('사업자 등록번호를 입력해 주세요.')
            return false
        }
        if (mbBizName === '') {
            setDialog('대표자 성명을 입력해 주세요.')
            return false
        }
        if (mbBizPaper === '') {
            setDialog('사업자 등록증을 첨부해 주세요.')
            return false
        }

        if (!checked1 || !checked2) {
            setDialog('약관에 전부 동의해 주세요.')
            return false
        }

        return true

    }

    const onSubmit = async() => {
        if (valid() === false) return setLoading(false)

        let formData = new FormData()
        let ip = ''

        // try {
        //     const response = await axios.get('https://api.ipify.org?format=json');
        //     ip = response.data.ip;
        //   } catch (error) {
        //     console.error(error);
        //     setLoading(false)
        //     return
        //   }

          formData.append("mb_id", mbId)
          formData.append("mb_password", mbpassword)
          formData.append("mb_name", mbName)
          formData.append("mb_email", mbEmail)
          formData.append("mb_hp", mbHp)
          formData.append("mb_zip1", mbZip1)
          formData.append("mb_zip2", mbZip2)
          formData.append("mb_addr1", mbAddr1)
          formData.append("mb_addr2", mbAddr2)
          formData.append("mb_addr3", mbAddr3)
          formData.append("mb_ip", ip)
          formData.append("mb_sms", mbSms)
          formData.append("mb_storename", mbStorename)
          formData.append("mb_biz_no", mbBizNo)
          formData.append("mb_biz_name", mbBizName)
          formData.append("mb_biz_tax_mail", mbBizTaxMail)
          formData.append("mb_biz_paper", mbBizPaper)
          formData.append("register_point", regPoint)
          
          try {
            const res = await axios.post(
                '/api/user/registerUser/',
                                  formData, 
                                  {
                                    headers: {
                                      'Content-Type': 'multipart/form-data'
                                    }
                                  }
           )
      
            if (res.data.success === false) {
                setDialog('회원가입에 실패하였습니다.')
                setLoading(false)
              return;
            }

            navigate("/RegisterSuccess");

            
        
          } catch (e) {
            console.log(e)
            setLoading(false)
          }
      

    }

    useEffect(() => {

        return () => {
            setMbId('')
            setMbPassword('')
            setMbPassCheck('')
            setName('')
            setMbZip1('')
            setMbZip2('')
            setMbAddr1('')
            setMbAddr2('')
            setMbAddr3('')
            setMbEmail('')
            setMbHp('')
            setMbSms(0)
            setMbStorename('')
            setMbBizNo('')
            setMbBizName('')
            setMbBizTaxMail('')
            setMbBizPaper('')
        }
      }, [])
    

    return(
        <div>
            <div className={classes.joinBlock}>
                <div className={classes.row}>
                    <h1 className={classes.joinH1}>회원가입</h1>
                    <div className={classes.joinTosFlexDiv}>
                        <div className={classes.joinForm}>
                            <h3 className={classes.appListH3}>기본정보</h3>
                            <ul className={classes.appList}>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>아이디</label>
                                    </div>
                                    <div className={classes.idOverlapDiv}>
                                        <div className={classes.appContentId}>
                                            <input 
                                                type='text' 
                                                className={classes.appContentInputId} 
                                                placeholder='아이디를 입력해주세요' 
                                                value={mbId}
                                                onChange={(e) => {
                                                    setIdCheck(false)
                                                    setIdHas(false)
                                                    setMbId(e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className={classes.appContentIdBtn}>
                                            <button 
                                                className={classes.pilsooItemIdBtn}
                                                onClick={checkId}
                                            >
                                                중복확인
                                            </button>
                                        </div>
                                    </div>
                                    {idCheck && (<h3 style={{color: '#8FBC8F'}}>사용가능한 아이디 입니다.</h3>)}
                                    {idHas && (<h3 style={{color: '#CD5C5C'}}>이미 존재하는 아이디 입니다.</h3>)}
                                    
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>비밀번호</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='password' 
                                            className={classes.appContentInput} 
                                            placeholder='비밀번호를 입력해주세요' 
                                            value={mbpassword}
                                            onChange={(e) => {setMbPassword(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>비밀번호 확인</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='password' 
                                            className={classes.appContentInput} 
                                            placeholder='비밀번호를 한번더 입력해주세요' 
                                            value={mbpassCheck}
                                            onChange={(e) => {setMbPassCheck(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>이름</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='이름을 입력해주세요' 
                                            value={mbName}
                                            onChange={(e) => {setName(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>주소</label>
                                    </div>
                                    <div>
                                        <Button 
                                            onClick={() => setOpen(true)} 
                                            style={{
                                                background:'#fff',
                                                color:'#007235',
                                                border:'1px solid #007235',
                                                width:'100%',
                                                marginBottom:'10px',
                                                fontFamily:[
                                                    'Noto Sans KR'
                                                ],
                                            }}
                                        >
                                            <CgSearch />
                                            주소검색
                                        </Button>
                                        <Modal
                                            open={open}
                                            onClose={() => setOpen(false)}
                                        >
                                            <Box sx={classes.addStyle}>
                                                <Typography 
                                                    id="modal-modal-description" 
                                                    variant="span" 
                                                    sx={{ 
                                                        mt: 2,
                                                    }}                                               
                                                >
                                                    <DaumPostcode 
                                                        onComplete={handle.selectAddress}  // 값을 선택할 경우 실행되는 이벤트
                                                        autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정 
                                                    />
                                                </Typography>
                                            </Box>
                                        </Modal>                                            
                                    </div>
                                    <div className={classes.appContent}>
                                        <h3>{mbZip1 + mbZip2}</h3>
                                        <h3>{mbAddr1}</h3>

                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='상세주소를 입력해주세요' 
                                            value={mbAddr2}
                                            onChange={(e) => {setMbAddr2(e.target.value)}}
                                        />
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            style={{marginTop: 5}}
                                            placeholder='상세주소를 입력해주세요 (선택)' 
                                            value={mbAddr3}
                                            onChange={(e) => {setMbAddr3(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>이메일</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='이메일을 입력해주세요' 
                                            value={mbEmail}
                                            onChange={(e) => {setMbEmail(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>휴대전화</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='숫자만 입력해주세요' 
                                            value={mbHp}
                                            onChange={(e) => {setMbHp(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>SMS 수신 동의</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <Checkbox
                                            checked={mbSms === 0 ? false : true}
                                            onChange={() => {
                                                mbSms === 0 ?
                                                setMbSms(1):
                                                setMbSms(0)
                                            }}
                                            size="small"
                                            style ={{
                                                color: "#007235",
                                                backgroundColor: '#F7FBF2'
                                            }}
                                            className={classes.checkbox}
                                        />       
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <h3 className={classes.appListH3}>사업자 등록</h3>
                                    <div 
                                        className={classes.paddingDiv}
                                        style={{ 
                                            padding: '40px 0 0 0px'
                                        }}
                                    >
                                        <label className={classes.pilsooItem}>사업자 등록증 업로드</label>               
                                    </div>
                                    <div className={classes.appContent}>
                                        {typeof(mbBizPaper) === 'string' ? mbBizPaper : mbBizPaper.name}
                                        <input 
                                            type="file" 
                                            accept=".gif, .jpg, .jpeg, .png, .pdf"
                                            onChange={(e) => {
                                                setMbBizPaper(e.target.files[0])
                                            }}
                                        />
                                        <Button     
                                            variant="outlined"
                                            onClick={() => {setMbBizPaper('')}}
                                            style={{
                                                color:'#007235',
                                                border:'1px solid #007235',
                                            }}
                                        >
                                            사업자 등록증 삭제
                                        </Button>
                                    </div>
                                    <label className={classes.pilsooItem}>(확장자 .gif, .jpg, .jpeg, .png, .pdf 만 업로드 가능)</label>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>상호명</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='상호명을 입력해주세요' 
                                            value={mbStorename}
                                            onChange={(e) => {setMbStorename(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>사업자 등록 번호</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='사업자 등록번호를 입력해주세요' 
                                            value={mbBizNo}
                                            onChange={(e) => {setMbBizNo(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>대표자성명</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='사업자 등록번호를 입력해주세요' 
                                            value={mbBizName}
                                            onChange={(e) => {setMbBizName(e.target.value)}}
                                        />
                                    </div>
                                </li>

                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>세금계산서 발행 메일 (선택)</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='세금계산서 발행 메일을 입력해주세요' 
                                            value={mbBizTaxMail}
                                            onChange={(e) => {setMbBizTaxMail(e.target.value)}}
                                        />
                                    </div>
                                </li>

                            </ul>

                        </div>

                        <div className={classes.TosForm}>
                            <h3 className={classes.appListH3}>약관동의</h3>
                            <div className={classes.Tos1}>
                                <h2 className={classes.formH2}>
                                    이용약관
                                </h2>
                                <textarea 
                                    value={tosStipulation}
                                    className={classes.formTextarea} disabled 
                                />
                                <div className={classes.checkBox}>
                                    <label className={classes.checkBoxLabel}>
                                        <Checkbox
                                            checked={checked1}
                                            onChange={(e) => setChecked1(e.target.checked)}
                                            size="small"
                                            style ={{
                                                color: "#007235",
                                                backgroundColor: '#F7FBF2'
                                            }}
                                            className={classes.checkbox}
                                        />
                                        이용약관에 동의합니다.(필수)
                                    </label>
                                </div>                        
                            </div>
                            <div className={classes.Tos2}>
                                <h3 className={classes.formH2}>
                                    개인 정보 수집 / 이용
                                </h3>
                                <textarea 
                                    value={tosprivacy}
                                    className={classes.formTextarea} 
                                    disabled 
                                />  
                                <div className={classes.checkBox}>
                                    <label className={classes.checkBoxLabel}>
                                        <Checkbox
                                            checked={checked2}
                                            onChange={(e) => setChecked2(e.target.checked)}
                                            size="small"
                                            style ={{
                                                color: "#007235",
                                                backgroundColor: '#F7FBF2'
                                            }}
                                            className={classes.checkbox}
                                        />
                                        개인 정보수집/이용에 동의합니다.(필수)
                                    </label>
                                </div>
                            </div>
                            
                            {loading ? (
                                <div>회원가입을 진행중입니다</div>
                            ) : (
                                <>
                                <button 
                                    onClick={() => {
                                        setLoading(true)
                                        setTimeout(() => onSubmit(), 1000)       
                                    }} 
                                    className={classes.formBtn}
                                >
                                    회원가입
                                </button>
                                </>
                            )}

                        </div> 
                    </div>
                </div>
            </div>

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                {dialog}
                </DialogTitle>
                <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                    확인
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Register;